import { useEffect, useRef, useState } from 'react';

export function useDebounce<T>(value: T, delay: number): T {
  const [debounced, setDebounced] = useState<T>(value);
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip debounce on mount — pass the initial value through immediately
    if (isFirstRender.current) {
      isFirstRender.current = false;
      setDebounced(value);
      return;
    }
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
